import { render, staticRenderFns } from "./addProductType.vue?vue&type=template&id=cf841346&scoped=true&"
import script from "./addProductType.vue?vue&type=script&lang=ts&"
export * from "./addProductType.vue?vue&type=script&lang=ts&"
import style0 from "./addProductType.vue?vue&type=style&index=0&id=cf841346&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf841346",
  null
  
)

export default component.exports